webpackJsonp([2],{

/***/ 132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _home = __webpack_require__(132);

var _home2 = _interopRequireDefault(_home);

var _jquery = __webpack_require__(10);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Home JS
 */

var $window = (0, _jquery2.default)(window);
var $scroll = (0, _jquery2.default)('.hero-scroll');
var $hero = (0, _jquery2.default)('.hero-home');

var opacityStart = 1;
var opacityEnd = 0;

var scaleStart = 1;
var scaleEnd = 1;

var translateStart = 0;
var translateEnd = 60;

(0, _jquery2.default)(window).scroll(function () {
  var scaler = 1 - ($window.scrollTop() - $hero.offset().top) / $hero.height();

  if (scaler > 1) {
    scaler = 1;
  } else if (scaler < 0) {
    scaler = 0;
  }

  $scroll.css('opacity', scaler * (opacityStart - opacityEnd) + opacityEnd).css('transform', 'scale(' + (scaler * (scaleStart - scaleEnd) + scaleEnd) + ') translate3d(0, ' + (scaler * (translateStart - translateEnd) + translateEnd) + 'px, 0)');
});

/***/ })

},[141]);


// WEBPACK FOOTER //
// home.e48bd5f1.js